import React, { useEffect, useState } from 'react';
import {
  EuropeassistanceRiskCardStyles,
  EuropQuoteInformationResultContainer,
  LeftColResult,
  LogoPriceContainer,
  PriceContainer,
  LogoResultContainer,
  PriceResult,
  QuoteInformationResultItem,
} from '../ResultPageComponents/v2/EuropeassistanceCardResult.styles';
import { BACKEND_BASE_URL } from '../../../../config';

function GuaranteesSelectedCard({ processingQuote, coverage, requestInfo }) {
  const [groupedCoverages, setGroupedCoverages] = useState([]);

  useEffect(() => {
    const travelGuarantees = processingQuote.quotation_data_travel_europeassistance.coverages;
    if (coverage.group_id !== null) {
      const group = travelGuarantees.filter((c) => c.group_id === coverage.group_id);

      setGroupedCoverages(group);
    } else {
      setGroupedCoverages([coverage]);
    }
  }, [coverage]);

  const getPrice = () => {
    let price = 0;
    for (let x = 0; x < groupedCoverages.length; x++) {
      const cov = groupedCoverages[x];
      price += cov.coverage_amount_gros;
    }

    return price;
  };

  const rawDataset = requestInfo?.insurance_request_travel?.extra_dataset;
  let extraDataset = rawDataset;
  if (typeof rawDataset === 'string') {
    try {
      extraDataset = JSON.parse(rawDataset);
    } catch (e) {
      extraDataset = null;
    }
  }

  return (
    <EuropeassistanceRiskCardStyles className="selected">
      <LeftColResult>

        <LogoPriceContainer>
          <LogoResultContainer>
            <img
              src={BACKEND_BASE_URL + processingQuote.company.logo}
              alt={`${processingQuote.company.name} Logo`}
            />
          </LogoResultContainer>
          <PriceContainer>
            <PriceResult>
              <h5>Prezzo annuo:</h5>
              <h2>
                €
                {parseFloat(getPrice()).toFixed(2)}
              </h2>
            </PriceResult>
          </PriceContainer>
        </LogoPriceContainer>

        <EuropQuoteInformationResultContainer>

          <QuoteInformationResultItem>
            <h6>Prodotto:</h6>
            <p>{processingQuote.quotation_data_travel_europeassistance?.product_name}</p>
          </QuoteInformationResultItem>
          {groupedCoverages.map((cov, index) => (
            <QuoteInformationResultItem key={index}>
              <h6>
                {cov.title}
                :
              </h6>
              <p>{cov.limit_desc}</p>
            </QuoteInformationResultItem>
          ))}

          {(coverage.coverage_id === '000001_EA1358' || coverage.coverage_id === '000001_EA1244') && extraDataset
            && (
              <>
                <QuoteInformationResultItem>
                  <h6>
                    Benificario
                    :
                  </h6>
                  <p>{extraDataset.value === '1' ? 'Eredi legittimi o testamentari' : 'Altra Persona'}</p>
                </QuoteInformationResultItem>
                {extraDataset.value === '2' && (
                  <QuoteInformationResultItem>
                    <h6>
                      Nome Benificario
                      :
                    </h6>
                    <p>{extraDataset.beneficario}</p>
                  </QuoteInformationResultItem>
                )}
              </>
            )}
        </EuropQuoteInformationResultContainer>
      </LeftColResult>
      {/* <RightColResult style={{ marginTop: '24px' }}>
        <SelectedGuaranteesContainerResult>
          <h6>
            <b>Garanzie</b>
            {' '}
            Aggiunte
          </h6>
          <GuaranteesListResult>
            {quote.quotation_data_travel_europeassistance.coverages.map(
              (coverage, index) => (
                <React.Fragment key={index}>
                  {coverage.enabled === 0 && coverage.group_id === null && (
                  <GuaranteesListItemResult>
                    <h6>
                      <span />
                      {' '}
                      {coverage.title}
                    </h6>
                    <p>
                      &euro;
                      {parseFloat(
                        coverage.coverage_amount_gros,
                      ).toLocaleString('en-US')}
                    </p>
                  </GuaranteesListItemResult>
                  )}
                  {quote.quotation_coverages.map(
                    (cov, index) => coverage.coverage_id === cov.guarantees_slug && (
                    <GuaranteesListItemResult key={index}>
                      <h6>
                        <span />
                        {' '}
                        {cov.guarantees_description}
                      </h6>
                      <p>
                        &euro;
                        {parseFloat(cov.amount).toLocaleString('en-US')}
                      </p>
                    </GuaranteesListItemResult>
                    ),
                  )}
                </React.Fragment>
              ),
            )}
          </GuaranteesListResult>
        </SelectedGuaranteesContainerResult>
      </RightColResult> */}
    </EuropeassistanceRiskCardStyles>
  );
}

export default GuaranteesSelectedCard;
